import type { AuthProviderFeatures } from '../../types';

export const CLIENT_APP_FEATURES: AuthProviderFeatures = {
  canUpdateProfile: true,
  canUpdateEmail: true,
  canChangePassword: true,
  canDeleteAccount: false,
  forgotPasswordFlow: 'email_link',
  emailChangeConfirmation: 'email_link',
  socialSignInFlow: 'sdk_token',
  socialProviders: ['google', 'facebook'],
  requiresSessionGuard: false,
};
